export const TSR_OFFICE_ADDRESS = {
  name: 'TSR Catering and Events',
  line1: 'From highway, enter next to leward hotel.',
  line2: 'Take left before Star Furniture, Gaon, Patil Nagar, Balewadi, Pune, Maharashtra 411045',
  singleLine:
    'TSR Catering and Events, From highway, enter next to leward hotel. Take left before Star Furniture, Gaon, Patil Nagar, Balewadi, Pune, Maharashtra 411045',
  schema: {
    streetAddress:
      'From highway, enter next to leward hotel. Take left before Star Furniture, Gaon, Patil Nagar',
    addressLocality: 'Balewadi, Pune',
    addressRegion: 'Maharashtra',
    postalCode: '411045',
    addressCountry: 'IN',
  },
};
